import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import addAppCustom from "./components/addAppCustom";
import customDetails from "./components/customDetails.vue";
import config from "@/config/index";
import downloadHistory from "./components/downloadHistory.vue";
import axios from "axios";
import { allocation_log, history_log, history_log_del, getdownloadtoken, area_list, get_downloadtoken } from "@/api/jingxiaoshang";
import { jingxiaoshang } from "@/api/api_url.js";
import { device_distribution_list } from "@/api/jingxiaoshang";
import { getcurrDate } from "@/libs/util";
import { commonReq } from "@/api/common";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      areaData: [],
      form_filter: {
        did: null,
        date: null,
        start_time: null,
        end_time: null,
        country_code: localStorage.getItem("country_code") ? localStorage.getItem("country_code") : "xciot-prod-cnsz"
      },
      //共用的查询与重置
      topButtonList: [{
        name: this.$t("query"),
        type: "primary",
        method: this.search
      }, {
        name: this.$t("reset"),
        type: "error",
        method: this.reset
      }],
      // //共用的右侧添加按钮
      topButtonList1: [{
        name: this.$t("export"),
        icon: "ios-download",
        type: "primary",
        method: this.export
      }],
      reqBase: {
        page: 1,
        page_size: 15,
        po: "",
        time_end: "",
        time_start: "",
        prev_time: ""
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      statusData3: [{
        value: "xciot-prod-cnsz",
        name: this.$t("Changelang.中国")
      }, {
        value: "xciot-prod-hk",
        name: this.$t("Changelang.香港")
      }, {
        value: "xciot-prod-us2",
        name: this.$t("美国")
      }, {
        value: "xciot-prod-eu",
        name: this.$t("Changelang.欧洲")
      }],
      getPageTotal: 0,
      operationButtonList: [{
        name: this.$t("查看"),
        type: "text",
        icon: "",
        method: this.details
      }],
      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [// {
      //   align: 'center',
      //   title: '序号',
      //   minWidth:120,
      //   key: 'id',
      // },
      {
        align: "center",
        title: this.$t("devicelist.did"),
        minWidth: 120,
        key: "did"
      }, {
        align: "center",
        title: this.$t("devicelist.recordtime"),
        minWidth: 120,
        key: "timestamp"
      }, {
        align: "center",
        title: this.$t("devicelist.electriccurrent"),
        minWidth: 120,
        key: "current"
      }, {
        align: "center",
        title: this.$t("devicelist.totalvoltage"),
        minWidth: 120,
        key: "voltage"
      }, {
        align: "center",
        title: this.$t("devicelist.remainingcapacity"),
        minWidth: 120,
        key: "remainder_capacity"
      }, {
        align: "center",
        title: this.$t("devicelist.fullchargecapacity"),
        minWidth: 120,
        key: "actual_capacity"
      }, {
        align: "center",
        title: this.$t("operation"),
        minWidth: 150,
        key: "Operating",
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = [];

          var _loop = function _loop(i) {
            var list = _this2.operationButtonList[i];
            arr.push(h("Button", {
              style: {
                marginLeft: "5px",
                marginBottom: "3px",
                color: "#2d8cf0"
              },
              props: {
                type: list.type,
                size: list.size ? list.size : "small"
              },
              on: {
                click: function click() {
                  list.method(row);
                }
              }
            }, list.name));
          };

          for (var i in _this2.operationButtonList) {
            _loop(i);
          }

          return h("div", arr);
        }
      }]
    };
  },
  props: {
    reducehe: {},
    code: {},
    hasDid: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {},
  methods: {
    export: function _export(row) {
      var _this3 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, vm.$t("exportTime")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(downloadHistory, {
            ref: "downloadHistory",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this3.code,
              dids: _this3.dids
            }
          })]);
        },
        onOk: function onOk() {
          var _this4 = this;

          var _this = this;

          var obj = this.$refs.downloadHistory;
          obj.checkForm().then(function (req) {
            if (vm.form_filter.did) {
              if (req) {
                var formModel = obj.formModel;
                var domain = vm.get_domain();
                var timeStart = new Date(formModel.start_time * 1000).getTime(); // 获取开始时间戳

                var timeEnd = new Date(formModel.end_time * 1000).getTime(); // 获取结束时间戳
                // 计算时间差（毫秒）并转为天数

                var diffTime = timeEnd - timeStart;
                var diffDays = diffTime / (1000 * 60 * 60 * 24); // 转换为天数

                console.log("111111111", diffDays); // 检查时间差是否大于7天

                if (diffDays > 7) {
                  _this4.$Message.error(vm.$t("请导出小于七天的数据"));
                } else {
                  get_downloadtoken({
                    type: "1",
                    country_code: vm.form_filter.country_code
                  }).then(function (res) {
                    _this.buttonLoading = false;

                    if (res.result === 0) {
                      var downloadtoken = res.body.downloadtoken;
                      commonReq("/index.php/admin/devicedetail/get_device_type", {
                        did: vm.form_filter.did
                      }).then(function (res) {
                        if (res.result === 0) {
                          var lang = localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
                          commonReq("/index.php/admin/device/history_daochu?lang=".concat(lang), {
                            type: 1,
                            downloadtoken: downloadtoken,
                            did: vm.form_filter.did,
                            time_start: formModel.start_time,
                            time_end: formModel.end_time
                          });
                          vm.$Message.success(vm.$t("导出成功"));
                          vm.$Modal.remove();
                          var routeData = vm.$router.push({
                            path: "/deviceman/downloadlist"
                          });
                          window.open(routeData.href, "_self"); // }
                        }
                      });
                    } else {
                      vm.$Message.error(res.errorMsg);
                    }
                  });
                }
              } else {
                _this.buttonLoading = false;
              }
            } else {
              _this4.$Message.error(vm.$t("请选择导出设备") + "ID");

              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_domain: function get_domain() {
      var result = "";

      if (process.env.NODE_ENV === "development") {
        result = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === "production") {
        result = config.baseUrl.pro;
      } else {
        result = config.baseUrl.alp;
      }

      return result;
    },
    //页码change
    nextpage: function nextpage(time_end) {
      // debugger
      console.log("nextpagetime_end", time_end);
      this.reqBase.time_end = time_end;
      this.reqBase.time_start = "";
      this.reqBase.type = "next";
      console.log("nextpage", this.reqBase); //this.reqBase.prev_time= prev_time

      this.init();
    },
    //页码change
    prevpage: function prevpage(prev_pages) {
      var prev_time = JSON.parse(prev_pages); // console.log("这里是上一页时间", prev_time[prev_time.length - 1]);
      // return;
      //this.reqBase.time_start = 0 //time_start;

      this.reqBase.type = "prev";

      if (prev_time.length == 2) {
        return;
      }

      this.reqBase.time_end = prev_time[prev_time.length - 3]; //time_start;

      if (this.reqBase.time_end == 0) {
        prev_time.pop();
        prev_time.pop(); //localStorage.setItem('prev_time', JSON.stringify([]));
      } else {
        prev_time.pop();
        prev_time.pop();
      }

      localStorage.setItem("prev_time", JSON.stringify(prev_time));
      this.init();
    },
    changeTime: function changeTime(val) {
      this.$set(this.form_filter, "date", val);
    },
    // mechanHome(row){
    //   window.open(config.webLinkUrl+'/index/'+row.company_code)
    // },
    // pageSizeChange(){
    // },
    getAreaData: function getAreaData() {
      var _this5 = this;

      return;
      this.areaData.splice(0);
      area_list({
        page: 1,
        page_size: 1000,
        parent_code: 1,
        all: 2,
        type: 1
      }).then(function (res) {
        if (res.result === 0) {
          //console.log(data)
          var data = res.body.list;

          _this5.checkTree(data);

          console.log("a", data);
          _this5.areaData = data;
        }
      });
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        if (arr[i].area_name) {
          arr[i].value = arr[i].area_code;
          arr[i].label = arr[i].area_name;
          arr[i].title = arr[i].area_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }

        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          var _arr$i$children;

          (_arr$i$children = arr[i].children).push.apply(_arr$i$children, _toConsumableArray(arr[i].children_shop));
        }

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    onSearch: function onSearch(params) {
      //重置当前页为1
      this.reqBase.page = 1;
      this.reqBase.time_end = "";
      this.reqBase.time_start = "";
      Object.assign(this.reqBase, params); //重置当前的page
      //this.$refs.contentBaseRef.initcurrentPage();

      this.init();
    },
    init: function init() {
      var _this6 = this;

      localStorage.setItem("country_code", this.form_filter.country_code);

      if (this.form_filter.date == "") {
        this.form_filter.date = getcurrDate();
        console.log("wode1chaxunshuju");
        this.reqBase.date = this.form_filter.date;
      }

      if (this.$route.query.did) {
        this.reqBase.did = this.$route.query.did;
        this.form_filter.did = this.$route.query.did;
      } // this.form_filter.date = getcurrDate()
      // this.form_filter.did = this.$route.query.did


      this.reqBase.date = this.form_filter.date; // this.reqBase.did=this.$route.query.did
      // if( this.form_filter.did){
      //   this.reqBase.did=this.form_filter.did
      // }

      this.getAreaData();
      this.tableLoading = true; //alert(this.reqBase.did)

      console.log("wode1chaxunshuju", this.reqBase, this.form_filter);
      history_log(_objectSpread({}, this.reqBase)).then(function (res) {
        _this6.tableLoading = false; //this.tableDataList = [];

        if (res.result === 0) {
          _this6.tableDataList = res.body.list || []; // console.log("this.tableDataList ",this.tableDataList )

          var len = _this6.tableDataList.length; // localStorage.setItem('time_start', this.tableDataList[0].time);
          // console.log("prev_time", this.tableDataList[0].time)

          if ("type" in _this6.reqBase && _this6.reqBase.type != "") {
            console.log("yes");
            var prev_pages = localStorage.getItem("prev_time");
            var prev_pages2 = JSON.parse(prev_pages);
            console.log("prev_pages2", prev_pages2);

            if (len > 0) {
              prev_pages2.push(_this6.tableDataList[len - 1].time);
            }

            console.log("prev_pages22", prev_pages2);
            localStorage.setItem("prev_time", JSON.stringify(prev_pages2));
          } else {
            console.log("no");
            var _prev_pages = [];

            _prev_pages.push(0);

            if (len > 0) {
              console.log("this.tableDataList[len-1]", _this6.tableDataList[len - 1]);

              _prev_pages.push(_this6.tableDataList[len - 1].time);
            }

            console.log("prev_pages11", _prev_pages);
            localStorage.setItem("prev_time", JSON.stringify(_prev_pages));
          } // let prev_pages = localStorage.getItem('prev_time')
          // if (prev_time == "") {
          //   let prev_pages = []
          //   prev_pages.push(this.tableDataList[0].time);
          // } else {
          //   prev_pages.push(this.tableDataList[0].time);
          // }


          if (len > 0) {
            localStorage.setItem("time_end", _this6.tableDataList[len - 1].time);
          }

          _this6.getPageTotal = res.body.total;
        } else {
          if (res.errorMsg == "数据为空") {
            _this6.$Message.error(res.errorMsg);

            return;
          }

          _this6.tableDataList = [];
          _this6.getPageTotal = 0;

          _this6.$Message.error(res.errorMsg);
        }
      });
    },
    search: function search() {
      this.form_filter.type = "";
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        did: null,
        date: null,
        time_end: null,
        time_start: null,
        country_code: localStorage.getItem("country_code") ? localStorage.getItem("country_code") : "xciot-prod-cnsz"
      };
      this.form_filter.type = "";
      this.search();
    },
    details: function details(row) {
      console.log("rowrowrowrow", row); // if (row.device_type == 1) {
      //   routeData = this.$router.resolve({
      //     path: "/deviceman/details",
      //     query: { did: row.did, web_time: row.timems },
      //   });
      // } else if (row.device_type == 2) {
      //   routeData = this.$router.resolve({
      //     path: "/deviceman/detailsdy",
      //     query: { did: row.did, web_time: row.timems },
      //   });
      // } else {
      //   routeData = this.$router.resolve({
      //     path: "/deviceman/detailscc",
      //     query: { did: row.did, web_time: row.timems },
      //   });
      // }
      // window.open(routeData.href, "_blank");
      // if (row.model_code == "GBMSMT") {
      //   const routeData = this.$router.push({
      //     path: "/deviceman/detailsNew",
      //     query: { did: row.did, tabs: "3" },
      //   });
      //   window.open(routeData.href, "_self");
      // } else {

      var routeData = null;

      if (row.device_type == 1) {
        routeData = this.$router.resolve({
          path: "/deviceman/details",
          query: {
            did: row.did,
            web_time: row.timems
          }
        });
      } else if (row.device_type == 2) {
        routeData = this.$router.resolve({
          path: "/deviceman/detailsdy",
          query: {
            did: row.did,
            web_time: row.timems
          }
        });
      } else if (row.device_type == 3) {
        routeData = this.$router.resolve({
          path: "/deviceman/detailscc",
          query: {
            did: row.did,
            web_time: row.timems
          }
        });
      } else if (row.device_type == 200) {
        routeData = this.$router.push({
          path: "/deviceman/detailsSCLI",
          query: {
            did: row.did,
            tabs: "1"
          }
        });
      } else {
        routeData = this.$router.resolve({
          path: "/deviceman/detailscc",
          query: {
            did: row.did,
            web_time: row.timems
          }
        });
      }

      window.open(routeData.href, "_blank"); // window.open(routeData.href, "_blank");
      // this.$router.push({
      //       name:'/alert',
      //       query:{
      //          'a':1
      //       }
      //     })
    },
    getDownloadUrl: function getDownloadUrl() {
      var result = "";

      if (process.env.NODE_ENV === "development") {
        result = config.baseUrl.dev + jingxiaoshang.downloadFile;
      } else if (process.env.VUE_APP_BUILD === "production") {
        result = config.baseUrl.pro + jingxiaoshang.downloadFile;
      } else {
        result = config.baseUrl.alp + jingxiaoshang.downloadFile;
      }

      return result;
    },
    download: function download(row) {
      var _this7 = this;

      var url = this.getDownloadUrl();
      console.log("a", url); // console.log(securitytask)
      // console.log(123)
      //  return

      var _this = this;

      var config = {
        loading: true,
        title: "下载",
        width: 400,
        content: "<p>\u786E\u8BA4\u4E0B\u8F7D\uFF1F</p>",
        onOk: function onOk() {
          console.log(row);

          var params = {
            shop_name: row.shop_name
          },
              callbak = function callbak(req) {
            _this7.$Modal.remove();

            _this7.init(); // console.log(url)
            // return


            url = url + "?downloadinfo=did&code=" + row.allocation_code + "&downloadtoken=" + req.body.downloadtoken;
            window.open(url);
          }; //导出接口


          var params1 = {
            downloadinfo: "did",
            code: row.allocation_code
          };
          getdownloadtoken(params1).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config); // allocation_add({...formModel}).then(res => {
      //           if (res.result === 0) {
      //             vm.$Message.success(res.errorMsg);
      //             vm.$Modal.remove();
      //             vm.init();
      //           } else {
      //             vm.$Message.error(res.errorMsg);
      //             _this.buttonLoading = false;
      //           }
      //         });
    },
    // del(row) {
    //   let vm = this;
    //   let config = {
    //     loading: true,
    //     title: '删除',
    //     content:'您确定要删除序号为'+row.id+'的数据吗',
    //     onOk: function () {
    //       let _this = this;
    //       history_log_del({ id: row.id }).then(res => {
    //         alert(res.result)
    //         console.log(res)
    //         debugger
    //         if (res.result == 0) {
    //           vm.$Message.success(res.errorMsg);
    //           vm.$Modal.remove();
    //           vm.init();
    //         } else {
    //           vm.$Message.error(res.errorMsg);
    //           _this.buttonLoading = false;
    //         }
    //       });
    //     }
    //   };
    //   this.$Modal.confirm(config);
    // }

    /**
     * 删除
     */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t("删除"),
        content: this.$t("您确定要删除序号为") + row.id + "?",
        loading: true,
        onOk: function onOk() {
          var _this = this;

          history_log_del({
            id: row.id
          }).then(function (res) {
            console.log(res);
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg = res.errorMsg;
              vm.$Message.success(_msg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var devlist, list;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return device_distribution_list({
                page: 1,
                page_size: 1,
                status: 2
              });

            case 2:
              devlist = _context.sent;

              if (devlist.result === 0) {
                list = devlist.body.list || [];

                if (list.length > 0) {
                  this.$set(this.reqBase, "did", list[0].did);
                  this.$set(this.form_filter, "did", list[0].did);
                }
              } else {}

              if (this.code) {
                this.$set(this.reqBase, "project_code", this.code);
              }

              if (this.reducehe) {
                this.reduceheight = this.reducehe;
              } else {
                this.init();
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  created: function created() {
    this.form_filter.date = getcurrDate(); // this.getPageSizeToStorage();
  }
};